import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import { Auth } from 'aws-amplify';
// import {toast} from 'react-toastify';
import { ToastContainer, toast } from 'react-toastify';
import Header from '../Header/header';
import { changePasswordData } from '../../Actions/actions';
import TextFieldGroup from '../common/TextFieldGroup';
import 'react-toastify/dist/ReactToastify.css';

class ForgotPasswordAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      password: '',
      cPassword: '',
      resetPassowrd: '',
      errors: {},
      isLoading: false,
      isReset: 1,
      errorsResetPasword: {},
      changePassword1: {},
      successUpdatePasswordState: false,
      message: '',
      email: localStorage.getItem('email'),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.isValidResetPasword = this.isValidResetPasword.bind(this);
    this.alertMesasage = this.alertMesasage.bind(this);
  }

  componentDidMount() {
    this.setState({ message: '' });
  }


  componentWillMount() {
    Auth.currentUserInfo().then((res) => {
      this.setState({
        email: res.attributes.email,
      });
    }).catch(error => error);
  }

  isValidResetPasword() {
    const { errorsResetPasword, isValidResetPasword } = this.validateInputResetPasword(this.state);

    if (!isValidResetPasword) {
      this.setState({ errorsResetPasword });
    }

    return isValidResetPasword;
  }

  validateInputResetPasword(data) {
    const errorsResetPasword = {};
    if (Validator.isEmpty(data.password)) {
      errorsResetPasword.password = 'Password is required';
      errorsResetPasword.passwordError = true;
    }
    if (Validator.isEmpty(data.cPassword)) {
      errorsResetPasword.cPassword = 'Conform password is required';
      errorsResetPasword.cPasswordError = true;
    }
    if (data.cPassword !== '') {
      if (data.cPassword !== data.password) {
        errorsResetPasword.cPassword = 'Conform password and password is not match';
        errorsResetPasword.cPasswordError = true;
      }
    }


    if (Validator.isEmpty(data.oldPassword)) {
      errorsResetPasword.oldPassword = 'Old password is required';
      errorsResetPasword.oldPasswordError = true;
    }

    return {
      errorsResetPasword,
      isValidResetPasword: isEmpty(errorsResetPasword),
    };
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value, errors: {}, errorsResetPasword: {} });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isValidResetPasword()) {
      this.setState({ errors: {}, successUpdatePasswordState: true });

      this.props.changePasswordData(this.state);
    }
  }

  alertMesasage() {
    // this.props.alert.success('Password changed successfuly');
    this.context.router.history.push('/');
  }

  componentDidUpdate() {
    const { changePassword } = this.props.data;
    const { changePassword1, successUpdatePasswordState } = this.state;
    if (successUpdatePasswordState === true) {
      if (changePassword !== undefined) {
        if (changePassword1 !== changePassword) {
          this.setState({
            changePassword1: changePassword,
            successUpdatePasswordState: false,
            // isLoader: false,
          });


          // ToastStore.success('Hey, it worked !');
        }
        if (changePassword.statusText === 'OK') {
          toast.info('Password successfully changed!', {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.info(changePassword, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    }
  }

  render() {
    const {
      oldPassword, isReset, password, cPassword, errorsResetPasword,
    } = this.state;
    // const {ForgetPasswordData, ResetPasswordData} = this.props.data;


    return (
      <span>
        <ToastContainer />
        <div className="container">
          <div className="main-content">
            <Header />

            <div className={isReset === 1 ? 'section-content  center-align login-content ' : 'hide'}>
              <h2>Reset password</h2>
              <p>Create a new password by completing the fields below.</p>

              <div className="row error-message">
                <form className="col s8 offset-s2">
                    <div className="row">
                      <div className="input-field col s12">
                  <TextFieldGroup
                                    field="oldPassword"
                                    label="Old Password"
                                    value={oldPassword}
                                    error={errorsResetPasword.oldPassword}
                                    onChange={this.onChange}
                                    type="password"
                                  />
                </div>
                      <div className="input-field col s12">
                  <TextFieldGroup
                                    field="password"
                                    label="New Password"
                                    value={password}
                                    error={errorsResetPasword.password}
                                    onChange={this.onChange}
                                    type="password"
                                  />
                </div>

                      <div className="input-field col s12">
                  <TextFieldGroup
                                    field="cPassword"
                                    label="Conform Password"
                                    value={cPassword}
                                    error={errorsResetPasword.cPassword}
                                    onChange={this.onChange}
                                    type="password"
                                  />
                </div>

                      <p className="invalid col s12">{this.state.message}</p>
                      <div className="col s12">
                  <button className="btn waves-effect waves-light primary-btn col s12" type="submit" name="action" onClick={this.handleSubmit}>
Change Password
                                  </button>
                </div>

                    </div>
                  </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

// ForgotPasswordAffiliate.contextTypes = {
//   router: PropTypes.object.isRequired
// }

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changePasswordData }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordAffiliate));
